import { Wrapper } from 'AppReact';
import styled, { css } from 'styled-components';

const template = styled.div`
  display: flex;
  align-items: center;
  padding-left: 7px;
  padding-right: 24px;
  height: 56px; 
  width: 100%;
  position: relative;

  span {
    display: none;
    position: absolute;
    right: 20px;
  }

  &:hover {
    span {
      display: unset;
    }
  }
`;

export default Wrapper(template);
